import { Injectable } from '@angular/core';
import { AllowedVal, AttributeStateService } from '@ntap/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeduplikacijaMjestoAttributeStateService extends AttributeStateService {
  private selectedMjestaSubject = new BehaviorSubject<object[]>([]);
  selectedItems$: Observable<object[]> =
    this.selectedMjestaSubject.asObservable();

  private selectedMjesta: object[] = [];

  public setSelectedMjesta(items: object[]): void {
    this.selectedMjesta = items;
    this.selectedMjestaSubject.next(items);
  }

  override getAllowedValues(
    attributeMetadata: any,
    objectData: any,
    viewName: string
  ): Observable<AllowedVal[]> {
    const selectedMjesta: object[] = this.selectedMjesta;

    const allowedValues: AllowedVal[] = selectedMjesta.map((item: any) => ({
      value: item['en~mjesto~id'],
      label: item['en~mjesto~glavni_naziv']
    }));

    return super.getAllowedValues(attributeMetadata, objectData, viewName).pipe(
      map((avs) => {
        return allowedValues.concat(avs);
      })
    );
  }
}
